import { BcAntenatalRadioTextboxField } from "../BcAntenatalRadioTextboxField";

class BritishColumbiaObstetricalFilePrenatalGeneticInvestigation {
    public SerumIntegratedPrenatalScreen: boolean;
    public IntegratedPrenatalScreen: boolean;
    public NonInvasivePrenatalTesting: boolean;
    public NonInvasivePrenatalTestingMedicalServicePlan: boolean;
    public Quad: boolean;
    public ChorionicVillusSampling: boolean;
    public Amniocentesis: boolean;
    public Declined: boolean;
    public Other: BcAntenatalRadioTextboxField;
    public Results: string;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFilePrenatalGeneticInvestigation>) {
        Object.assign(this, fields);
        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
    }
}

export { BritishColumbiaObstetricalFilePrenatalGeneticInvestigation };
